
//Data expected from Wiki (or got otherwise if not present)

export const filterData = {
  'Summary': {"name": "Summary"},
  'Key Facts': {"name": "Facts"},
  "About": {"name":"About"},
  'News': {"name": "News"},
  'Financial Details': {"name": "Financials"},
  "cyberIncidents": {"name": "Company Incidents","subtitle":"Recent cybersecurity incidents at this company"},
  "cyberPartner": {"name": "Partnership"},
  "cyber_other": {"name": "Cyber news"},
  "tenK_cyber": {"name": "Internal View","subtitle":"Official communications on cybersecurity"},
  "cyberIndustryNews": {"name": "Competitor Incidents","subtitle":"Recent cybersecurity incidents at competing companies"},
  "cyberIndustryNewsV2": {"name": "Industry News","subtitle":"Industry-specific cybersecurity news"},
  "websiteTechStack": {"name": "Website tech stack"}
}

export const generalWikiData = ['revenue', 'employees', 'industry','website','key people', 'type'];
export const displaySummaryData = ['revenue', 'employees', 'industry','website','key people', 'type','competitors'];
export const extraWikiData = ['imageLogo','summaryText','Traded as'];
export const analyticsHoverTime_secs = 3.9;

export const missingKeysQuery = {
    'industry': ["what industry is "," in?"],
    'employees': ["what is "," employee count?"],
    'revenue': ["what is "," annual revenue?"]
}

export const currYear = "2020";

export const maxNewsArticles = 4;
export const maxFundingNewsArticles = 3;

export const maxParasForNewsSummary = 4;

export const generalCompanyNewsQuery = [
    {
      data: '# company',
      type: 'news'
    },
    {
      data: '# company growth',
      type: 'news'
    },
    {
      data: '# company news',
      type: 'search'
    }
  //  [' company raises funding']
]

export const cyberCompanyNewsQuery = [
    {
      data: '# company hacked news',
      type: 'search'
    },
    {
      data: '# company cyberattack news',
      type: 'search'
    },
    {
      data: '# company DDOS news',
      type: 'search'
    },
    {
      data: '# company data breach news',
      type: 'search'
    },
    {
      data: '# company network attack news',
      type: 'search'
    },
    {
      data: '# company malware attack news',
      type: 'search'
    },
    {
      data: '# company cyberattack',
      type: 'news'
    }
]

export const cyberIndustryCompanyNewsQuery = [
  {
    data: '# company hacked news',
    type: 'search'
  },
  {
    data: '# company cyberattack news',
    type: 'search'
  },
  {
    data: '# company DDOS news',
    type: 'search'
  },
  {
    data: '# company data breach news',
    type: 'search'
  }
]

export const cyberIndustryNewsQuery = [
  {
    data: '# cyber security news',
    type: 'search'
  },
  {
    data: '# cyber attack news',
    type: 'search'
  }
]

export const cyberSECFields = ['cyber-attack','cyberattack','cyber attack','cybersecurity','unauthorized','ransomware',
'denial of service','hack','breach', 'data', 'customer data','privacy']

// export const yahooFields = ["Total Revenue","Cost of Revenue","Gross Profit","Operating Income","EBITDA"]
export const yahooFields = ["Total Revenue","Cost of Revenue","Operating Income"]
export const amChartFieldsColors = {
  "Cost of Revenue": {"high": "#a55", "low": "green"}
}


export const updatePeriodForData = {
  "yahooIncomeStatement": 182*24*60*60*1000,  //182 days
}


export const cyberNewsKeywordsForUI = {
  'all': ['cyberattack','cyber-attack','hacked','hacker','hacking','ddos','denial of service','ransomware','breach','data','privacy',
  'users','million','malware','phishing','endpoint','network','cyber security','cybersecurity','cyber-secure','threats'],
  'General cyber-attacks': ['cyberattack','cyber-attack','hacked','hacker','hacking','cyber security','cybersecurity','cyber-secure','threats'],
  'Ransomware': ['ransomware'],
  'Malware': ['malware'],
  'Denial of service': ['ddos', 'denial of service'],
  'Phishing': ['phishing'],
  'Breaches': ['privacy','breach','data','million','users']
}

export const cyberNewsKeywordsFilterCategory = [
  'General cyber-attacks', 'Ransomware', 'Malware', 'Denial of service',
  'Phishing', 'Breaches'
]

export const Minute = 60*1000;
export const Hour = 60*Minute;
export const Day = 24*Hour;
export const Month = 30*Day;

export const entityCommonLen = 3;
export const verbLen = 2;

export const commonVerbs = {"be":"","have":"","do":"","will":"","run":"","can":"","am":""}